export default __webpack_public_path__ + "static/media/Role_gg.ec89e4be.png";